import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
  RootContainer,
  Logo,
  Form,
  NavContainer,
  BackIcon,
} from "./PasswordLogin.style";
import { Button } from "antd";
import { api } from "@api";
import { useDispatch } from "react-redux";
import { saveToken, saveUser } from "@redux/auth/authSlice";
import { openAlert } from "@redux/app/appSlice";
import { localStorage, getFingerprintData } from "@utils";
import { Alert } from "@components";
import { useTranslation } from "react-i18next";
import { InputPassword } from "@components";
import { setHasWithdrawAccount } from "@redux/app/appSlice";

const PasswordLogin = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state: phone } = useLocation();
  const [loading, setLoading] = useState(false);

  const onFinish = ({ password }) => {
    if (!loading) {
      if (password.length !== 6) {
        showAlert({
          message: t("auth.passwordLengthValidateMessage"),
          isError: true,
        });
        return;
      }
      setLoading(true);
      getFingerprintData()
        .then(device_info => {
          api
            .login({
              phone,
              password,
              device_info,
            })
            .then(({ user }) => {
              setLoading(false);
              successCallback(user);
              showAlert({
                message: t("auth.passwordLoginSuccessMessage"),
                successCallback: () => navigate(`/${PUBLIC_ROUTE.HOME}`),
              });
              getUserPayments();
            })
            .catch((errorMsg) => {
              setLoading(false);
              showAlert({
                message: errorMsg,
                isError: true,
              });
            });
        })
        .catch(() => { });
    }
  };

  const successCallback = ({ token, ...user }) => {
    // save token and user to redux
    dispatch(saveToken(token));
    dispatch(saveUser(user));

    // save token and user to localstorage
    localStorage.setToken(token);
    localStorage.setUser(user);

    // set token to request obj
    api.setSessionToken(token);
  };

  const getUserPayments = () => {
    api
      .getUserPayments()
      .then(({ user_payments }) => {
        dispatch(setHasWithdrawAccount(user_payments.length > 0));
      })
      .catch(() => { });
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goBack = () => {
    navigate(-1);
  };

  if (!phone) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
  }

  return (
    <>
      <RootContainer>
        <NavContainer>
          <BackIcon onClick={goBack} />
        </NavContainer>
        <Logo />
        <Form layout="vertical" requiredMark={false} onFinish={onFinish}>
          <Form.Item
            name="password"
            label={t("auth.passwordLoginPassword")}
            rules={[
              {
                required: true,
                message: "",
              },
              {
                pattern: /^[0-9]{6}$/,
                message: t("auth.createPasswordValidate"),
              },
            ]}
          >
            <InputPassword
              autoFocus
              placeholder={t("auth.passwordLoginPlaceholder")}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={loading}
            >
              {t("common.continue")}
            </Button>
          </Form.Item>
        </Form>
      </RootContainer>
      <Alert />
    </>
  );
};

export default PasswordLogin;
